import { OwnerFieldFragment } from 'generated/resources/graphql'

export const getOwnerFieldDefaultValues = (data?: OwnerFieldFragment | null) => {
  return {
    employee: data?.owner?.employeeName,
  }
}
